import styles from './ProgressRail.module.css';

type ProgressRailProps = {
  /** Current 1-indexed step. */
  current: number;
  /** Total number of steps rendered as dots. Defaults to 6 (the
   *  onboarding flow — Step 7 Welcome hides the rail entirely). */
  total?: number;
};

/**
 * 6-dot progress rail with expanding-fill active state. Used in the
 * onboarding shell.
 *
 * Dot states:
 *   - `current` step: 18px wide, --signal filled (active emphasis)
 *   - `< current` (completed): 5px wide, --signal filled
 *   - `> current` (pending):   5px wide, --ink-200 filled
 *
 * Rail is hidden on Step 7 Welcome (render this component
 * conditionally in the shell, or pass a small `total` to effectively
 * skip it).
 */
export function ProgressRail({ current, total = 6 }: ProgressRailProps) {
  return (
    <div className={styles.rail} role="progressbar" aria-valuenow={current} aria-valuemin={1} aria-valuemax={total}>
      {Array.from({ length: total }, (_, i) => {
        const step = i + 1;
        const state =
          step === current ? 'active' : step < current ? 'completed' : 'pending';
        return (
          <span
            key={step}
            className={[styles.dot, styles[state]].filter(Boolean).join(' ')}
            aria-hidden
          />
        );
      })}
    </div>
  );
}
